function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import moment from 'moment';
import _ from 'lodash';
import { convertDate } from 'shared/helpers/date-time';
// eslint-disable-next-line import/no-cycle
import { getProductWeight, saleSatisfiesWeightCondition } from './products';
// eslint-disable-next-line import/no-cycle
import { eligibleProductOptionsForRestriction } from './specials-3-5';
var LA_TIMEZONE = 'America/Los_Angeles';
export var currentSpecialsFilter = function(special) {
    var _special_recurring, _special_recurring1;
    // Analogous to currentParams Mongo-based logic
    var now = moment().toDate();
    var basicFilters = special.active && !special.complete && special.version >= 2;
    var recurringFilters = !special.isRecurring && special.endStamp > now || special.isRecurring && (!((_special_recurring = special.recurring) === null || _special_recurring === void 0 ? void 0 : _special_recurring.setEndDate) || ((_special_recurring1 = special.recurring) === null || _special_recurring1 === void 0 ? void 0 : _special_recurring1.endDate) > now);
    return basicFilters && recurringFilters;
};
export var days = moment.weekdays(false);
export var dayAbbreviations = [
    {
        key: 1,
        day: "Mon"
    },
    {
        key: 2,
        day: "Tue"
    },
    {
        key: 3,
        day: "Wed"
    },
    {
        key: 4,
        day: "Thu"
    },
    {
        key: 5,
        day: "Fri"
    },
    {
        key: 6,
        day: "Sat"
    },
    {
        key: 0,
        day: "Sun"
    }
];
export var defaultAdvancedConditionOptions = function(type) {
    var weight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Any Weight';
    return _object_spread({
        enabled: true
    }, type === 'quantity' ? {
        quantity: ''
    } : {}, type === 'maxQuantity' ? {
        maxQuantity: ''
    } : {}, type === 'quantity' ? {
        quantityOperator: 'equalTo'
    } : {}, type === 'weight' ? {
        weight: weight
    } : {}, type === 'weight' ? {
        weightOperator: 'equalTo'
    } : {}, type === 'spend' ? {
        minimumSpend: 0,
        maximumSpend: 0
    } : {}, type === 'spend' ? {
        spendOperator: 'greaterThanEqualTo'
    } : {});
};
// Used as reducer to extract .exclusions from an object (Relevant to special v3.5)
var extractExclusions = function(prev, curr) {
    var _curr_exclusions;
    if ((curr === null || curr === void 0 ? void 0 : (_curr_exclusions = curr.exclusions) === null || _curr_exclusions === void 0 ? void 0 : _curr_exclusions.length) > 0) {
        return prev.concat(curr.exclusions);
    }
    return prev;
};
export var extractSaleExclusions = function(special) {
    var _special_saleDiscounts, _special_excludedProducts;
    // v3.5
    if ((special === null || special === void 0 ? void 0 : (_special_saleDiscounts = special.saleDiscounts) === null || _special_saleDiscounts === void 0 ? void 0 : _special_saleDiscounts.length) > 0) {
        return _.reduce(special.saleDiscounts, extractExclusions, []);
    }
    // v3.0
    return (special === null || special === void 0 ? void 0 : (_special_excludedProducts = special.excludedProducts) === null || _special_excludedProducts === void 0 ? void 0 : _special_excludedProducts.length) > 0 ? _to_consumable_array(special.excludedProducts) : [];
};
export var getDaysList = function(daysArr) {
    var dayList = _.map(daysArr, function(key) {
        return _.find(dayAbbreviations, [
            "key",
            key
        ]);
    });
    // eslint-disable-next-line lodash/prefer-lodash-method
    return dayList.sort(function(a, b) {
        return a.key - b.key;
    }).map(function(d) {
        return d.day;
    }).join(', ');
};
export var specialIsRecurring = function(special) {
    if (!special.recurring) {
        return false;
    }
    return special.isRecurring;
};
export var specialHasAdvancedConditions = function(special) {
    var _special_bogoConditions, _special_totalSpend, _special_totalWeight, _special_totalQuantity;
    return special.specialType === 'bogo' && (!special.bogoConditions || ((_special_bogoConditions = special.bogoConditions) === null || _special_bogoConditions === void 0 ? void 0 : _special_bogoConditions.length) === 0) && (((_special_totalSpend = special.totalSpend) === null || _special_totalSpend === void 0 ? void 0 : _special_totalSpend.enabled) || ((_special_totalWeight = special.totalWeight) === null || _special_totalWeight === void 0 ? void 0 : _special_totalWeight.enabled) || ((_special_totalQuantity = special.totalQuantity) === null || _special_totalQuantity === void 0 ? void 0 : _special_totalQuantity.enabled));
};
export var specialHasRequiredProducts = function(special, filteredProducts) {
    // if filtered products is undefined, skip validation and return true
    if (!filteredProducts) {
        return true;
    }
    // filtered products are serialized with special data
    // reduce the set of specials tied to products and compare with input special
    var specialHasProducts = filteredProducts.some(function(product) {
        var specials = _to_consumable_array(product.specialData.bogoSpecials || []).concat(_to_consumable_array(product.specialData.saleSpecials || []));
        return specials.some(function(productSpecial) {
            return productSpecial.specialId === special._id || productSpecial.sourceId === special.posDiscountId;
        });
    });
    // if the special is for min spend and there are no other conditions, it applies to all products
    return specialHasAdvancedConditions(special) || specialHasProducts;
};
export var getAdjustedRecurringConfig = function(param) {
    var recurringDays = param.days, endTime = param.endTime, startTime = param.startTime, timezone = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : LA_TIMEZONE;
    var dateFormat = 'yyyy-MM-DD';
    var timeFormat = 'hh:mm A';
    var dateTimeFormat = "".concat(dateFormat, " ").concat(timeFormat);
    var today = moment.tz(timezone).format(dateFormat);
    /**
   * The reason we need to include the date here is because for some reason without it, the time is created for
   * the next day in some cases, and thus will cause the specialIsActive result to be incorrect.
   */ var specialStartToday = moment.tz("".concat(today, " ").concat(startTime), dateTimeFormat, timezone);
    var specialEndToday = moment.tz("".concat(today, " ").concat(endTime), dateTimeFormat, timezone);
    var startDays = recurringDays;
    var endDays = recurringDays;
    // if the end time is earlier than the start time,
    // that probably means the end time is on the next calendar day
    // OR it means the start time is on the previous calendar day
    // Example: enterprise has set a special to be 9:00 AM - 11:45 PM Pacific time
    // this would be 12:00 PM - 2:45 AM for an east coast dispensary.
    if (specialEndToday.isBefore(specialStartToday) && endTime && startTime) {
        // Dispensary is in a more western timezone than what the enterprise selected
        // move start days back
        if (specialStartToday.hour() > 12) {
            startDays = _.map(startDays, function(day) {
                return day === 0 ? 6 : day - 1;
            });
            specialStartToday = specialStartToday.add(-1, 'd');
        } else {
            endDays = _.map(endDays, function(day) {
                return day === 6 ? 0 : day + 1;
            });
            specialEndToday = specialEndToday.add(1, 'd');
        }
    }
    return {
        endDays: endDays,
        endTime: specialEndToday,
        startDays: startDays,
        startTime: specialStartToday
    };
};
var recurringSpecialIsActiveNow = function(special) {
    var timezone = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : LA_TIMEZONE;
    var now = moment();
    var _special_recurring = special.recurring, setEndDate = _special_recurring.setEndDate, endDate = _special_recurring.endDate;
    if (!setEndDate || now.isBefore(endDate)) {
        var _special_recurring1, _special_recurring2, _special_recurring3, _special_recurring4;
        var _getAdjustedRecurringConfig = getAdjustedRecurringConfig(special.recurring, timezone), endDays = _getAdjustedRecurringConfig.endDays, endTime = _getAdjustedRecurringConfig.endTime, startDays = _getAdjustedRecurringConfig.startDays, startTime = _getAdjustedRecurringConfig.startTime;
        if (!_.includes(_to_consumable_array(endDays).concat(_to_consumable_array(startDays)), Number(now.format("d")))) {
            return false;
        }
        // Support for "open all day" if special was generated by LLx
        if (special.source === 'POS' && !((_special_recurring1 = special.recurring) === null || _special_recurring1 === void 0 ? void 0 : _special_recurring1.startTime) && !((_special_recurring2 = special.recurring) === null || _special_recurring2 === void 0 ? void 0 : _special_recurring2.endTime)) {
            return true;
        }
        if (!((_special_recurring3 = special.recurring) === null || _special_recurring3 === void 0 ? void 0 : _special_recurring3.startTime) || !((_special_recurring4 = special.recurring) === null || _special_recurring4 === void 0 ? void 0 : _special_recurring4.endTime)) {
            return false;
        }
        return now.isBetween(startTime, endTime);
    }
    return false;
};
export var specialIsActive = function(special) {
    var timezone = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : LA_TIMEZONE;
    if (special.active) {
        if (specialIsRecurring(special)) {
            return recurringSpecialIsActiveNow(special, timezone);
        }
        if (!special.startStamp || !special.endStamp) {
            return false;
        }
        var now = moment();
        var startStamp = moment(special.startStamp).isValid() ? moment(special.startStamp) : moment(special.startStamp, 'x');
        var endStamp = moment(special.endStamp).isValid() ? moment(special.endStamp) : moment(special.endStamp, 'x');
        var nowIsSameOrAfterStart = now.isSameOrAfter(startStamp);
        var nowIsSameOrBeforeEnd = now.isSameOrBefore(endStamp);
        return nowIsSameOrAfterStart && nowIsSameOrBeforeEnd;
    }
    return false;
};
export var specialStarted = function(special) {
    var now = moment();
    var stampToUse = getEarliestStartStamp(special);
    return now.isAfter(moment(stampToUse));
};
export var getCloseDate = function() {
    var hoursType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "pickupHours", dispensary = arguments.length > 1 ? arguments[1] : void 0;
    var dispensaryTimezone = dispensary.timezone || LA_TIMEZONE;
    var today = days[new Date().getDay()];
    var hours = _.get(dispensary, hoursType, "8:00 PM");
    return convertDate(hours[today].end, dispensaryTimezone);
};
export var getLatestOpenTime = function(dispensary) {
    var lastPickupTime = getCloseDate("pickupHours", dispensary);
    var lastDeliveryTime = getCloseDate("deliveryHours", dispensary);
    return moment.max([
        lastPickupTime,
        lastDeliveryTime
    ]);
};
export var addDays = function(date, daysProp) {
    var result = new Date(date);
    result.setDate(result.getDate() + daysProp);
    return result;
};
export var specialIsPending = function(special) {
    var now = moment();
    var stampToUse = getEarliestStartStamp(special);
    return special.active && now.isBefore(stampToUse);
};
export var segmentCurrentAndPendingSpecials = function() {
    var specials = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return _.reduce(specials, function(accumulator, special) {
        accumulator[specialIsPending(special) ? 1 : 0].push(special);
        return accumulator;
    }, [
        [],
        []
    ]);
};
export var parseDates = function(special) {
    var endDay = special.endDay, endStamp = special.endStamp, schedule = special.schedule, startDay = special.startDay, startStamp = special.startStamp, isRecurring = special.isRecurring, recurring = special.recurring, version = special.version;
    var specialObj = special;
    if (version === 4) {
        _.set(specialObj.schedule, "endStamp", schedule.endStamp && moment(schedule.endStamp, [
            "x",
            moment.ISO_8601
        ]).toDate());
        _.set(specialObj.schedule, "startStamp", schedule.startStamp && moment(schedule.startStamp, [
            "x",
            moment.ISO_8601
        ]).toDate());
    }
    _.set(specialObj, "endDay", endDay && moment(endDay, [
        "x",
        moment.ISO_8601
    ]).toDate());
    _.set(specialObj, "endStamp", endStamp && moment(endStamp, [
        "x",
        moment.ISO_8601
    ]).toDate());
    _.set(specialObj, "startDay", startDay && moment(startDay, [
        "x",
        moment.ISO_8601
    ]).toDate());
    _.set(specialObj, "startStamp", startStamp && moment(startStamp, [
        "x",
        moment.ISO_8601
    ]).toDate());
    if (isRecurring && (recurring === null || recurring === void 0 ? void 0 : recurring.setEndDate)) {
        _.set(specialObj, "recurring.endDate", moment(recurring === null || recurring === void 0 ? void 0 : recurring.endDate, [
            "x",
            moment.ISO_8601
        ]).toDate());
    }
    return specialObj;
};
// Currently not used by anything, but if it is at some point, just uncomment and import!
// export const decodeBrandName = (brandName) =>
//   `${brandName}`
//     .replace('\\u002e', '.')
//     .replace('\\u0024', '$')
//     .replace('\\\\', '\\');
// Used because Mongo does not allow keys with \, $, or ., and encodeURI / encodeURIComponent does not encode all of
// those characters: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
export var encodeBrandName = function(brandName) {
    return !_.isEmpty(brandName) ? "".concat(brandName).replace(/\//g, '\\\\').replace(/\$/g, "\\u0024").replace(/\./g, "\\u002e") : '';
};
export var isDiscountApplied = function(costBreakdown) {
    var _costBreakdown_receipt;
    var _ref = costBreakdown === null || costBreakdown === void 0 ? void 0 : (_costBreakdown_receipt = costBreakdown.receipt) === null || _costBreakdown_receipt === void 0 ? void 0 : _costBreakdown_receipt.summary, _ref_discounts = _ref.discounts, discounts = _ref_discounts === void 0 ? 0 : _ref_discounts;
    return discounts > 0;
};
export var compareProductWeightToConditionWeight = function(condition, option) {
    if (_.isNil(condition.weight) || condition.weight === 'Any Weight' || condition.weight === 'N/A') {
        return true;
    }
    var conditionWeight = getProductWeight(condition.weight);
    var detailWeight = getProductWeight(option);
    return condition.weightOperator === 'greaterThan' ? detailWeight > conditionWeight : detailWeight === conditionWeight;
};
/**
 * Checks if a product has an active sale special that applies to the given menu type
 *
 * @param {Object} params - The parameters object
 * @param {Object} params.product - The product to check for sale specials
 * @param {boolean} params.medicalOrder - Whether this is for a medical order
 * @param {string} [params.menuType] - Optional menu type to check against. If not provided, uses medicalOrder to determine type
 * @returns {boolean} True if the product has an applicable sale special for the menu type
 */ export var hasSaleSpecialForMenuType = function(param) {
    var product = param.product, medicalOrder = param.medicalOrder, menuType = param.menuType;
    var isMedicalOrder = !_.isNil(medicalOrder) ? medicalOrder === true : menuType === 'med' || menuType === 'medical';
    if (isMedicalOrder) {
        return !_.isEmpty(product.medicalSpecialPrices);
    }
    return !_.isEmpty(product.recSpecialPrices);
};
export var specialMatchesMenuType = function(special, menuType) {
    return !special.menuType || special.menuType === 'both' || special.menuType === 'medical' && menuType === 'med' || special.menuType === 'recreational' && menuType === 'rec';
};
export var productHasSaleSpecial = function(param) {
    var product = param.product, medicalOrder = param.medicalOrder, menuType = param.menuType;
    var hasOriginalSaleSpecial = hasSaleSpecialForMenuType({
        product: product,
        medicalOrder: medicalOrder,
        menuType: menuType
    });
    var hasWeightedSpecial = productHasWeightOnSale(product);
    return hasOriginalSaleSpecial && hasWeightedSpecial;
};
export function productHasWeightOnSale(product) {
    var formattedOptions = product.formattedOptions;
    return _.some(formattedOptions || [], function(productWeight) {
        var _product_specialData;
        return ((_product_specialData = product.specialData) === null || _product_specialData === void 0 ? void 0 : _product_specialData.saleSpecials) ? productSatisfiesSaleWeight(product, product.specialData.saleSpecials, productWeight) : true;
    });
}
export function productIsExcludedFromOffer(product, currentSpecialId) {
    var _product_specialData, _currentSpecial_excludedProducts_conditions, _currentSpecial_excludedProducts, _currentSpecial_excludedProducts_rewards, _currentSpecial_excludedProducts1, _currentSpecial_excludedProducts_conditions1, _currentSpecial_excludedProducts2, _currentSpecial_itemsForAPrice;
    var currentSpecial = _.find(product === null || product === void 0 ? void 0 : (_product_specialData = product.specialData) === null || _product_specialData === void 0 ? void 0 : _product_specialData.bogoSpecials, [
        'specialId',
        currentSpecialId
    ]);
    var productIsExcludedFromConditionsAndRewards = (currentSpecial === null || currentSpecial === void 0 ? void 0 : (_currentSpecial_excludedProducts = currentSpecial.excludedProducts) === null || _currentSpecial_excludedProducts === void 0 ? void 0 : (_currentSpecial_excludedProducts_conditions = _currentSpecial_excludedProducts.conditions) === null || _currentSpecial_excludedProducts_conditions === void 0 ? void 0 : _currentSpecial_excludedProducts_conditions.length) > 0 && (currentSpecial === null || currentSpecial === void 0 ? void 0 : (_currentSpecial_excludedProducts1 = currentSpecial.excludedProducts) === null || _currentSpecial_excludedProducts1 === void 0 ? void 0 : (_currentSpecial_excludedProducts_rewards = _currentSpecial_excludedProducts1.rewards) === null || _currentSpecial_excludedProducts_rewards === void 0 ? void 0 : _currentSpecial_excludedProducts_rewards.length) > 0;
    var productIsExcludedFromConditionsAndIFAPEnabled = (currentSpecial === null || currentSpecial === void 0 ? void 0 : (_currentSpecial_excludedProducts2 = currentSpecial.excludedProducts) === null || _currentSpecial_excludedProducts2 === void 0 ? void 0 : (_currentSpecial_excludedProducts_conditions1 = _currentSpecial_excludedProducts2.conditions) === null || _currentSpecial_excludedProducts_conditions1 === void 0 ? void 0 : _currentSpecial_excludedProducts_conditions1.length) > 0 && (currentSpecial === null || currentSpecial === void 0 ? void 0 : (_currentSpecial_itemsForAPrice = currentSpecial.itemsForAPrice) === null || _currentSpecial_itemsForAPrice === void 0 ? void 0 : _currentSpecial_itemsForAPrice.enabled);
    var excludedProductsExist = productIsExcludedFromConditionsAndRewards || productIsExcludedFromConditionsAndIFAPEnabled;
    if (excludedProductsExist) {
        var _currentSpecial_itemsForAPrice1;
        var excludedProducts = currentSpecial.excludedProducts;
        var conditions = excludedProducts.conditions, rewards = excludedProducts.rewards;
        // if IFAP is enabled rewards exclusions will be undefined so we only check conditions
        // otherwise we only exclude products that are in both exclusion lists
        var excludedProductsToCheck = (currentSpecial === null || currentSpecial === void 0 ? void 0 : (_currentSpecial_itemsForAPrice1 = currentSpecial.itemsForAPrice) === null || _currentSpecial_itemsForAPrice1 === void 0 ? void 0 : _currentSpecial_itemsForAPrice1.enabled) ? conditions : _.intersectionBy(conditions, rewards, '_id');
        return _.some(excludedProductsToCheck, function(param) {
            var _id = param._id;
            return product._id === _id;
        });
    }
    return false;
}
export var productHasAtLeastOneQualifyingOption = function(product, offerId) {
    var _product_specialData;
    var matchingOffer = _.find((_product_specialData = product.specialData) === null || _product_specialData === void 0 ? void 0 : _product_specialData.bogoSpecials, function(param) {
        var specialId = param.specialId, sourceId = param.sourceId;
        return specialId === offerId || sourceId === offerId;
    });
    var qualifyingOptions = _.filter(product.formattedOptions || product.Options, function(option) {
        return _.includes(matchingOffer === null || matchingOffer === void 0 ? void 0 : matchingOffer.qualifyingOptions, option);
    });
    return qualifyingOptions.length > 0;
};
export function productIsPartOfActiveSpecial(product, menuType) {
    var _product_specialData, __filter, _product_specialData1;
    if (!((_product_specialData = product.specialData) === null || _product_specialData === void 0 ? void 0 : _product_specialData.bogoSpecials)) {
        return false;
    }
    return ((__filter = _.filter(((_product_specialData1 = product.specialData) === null || _product_specialData1 === void 0 ? void 0 : _product_specialData1.bogoSpecials) || [], function(special) {
        return specialMatchesMenuType(special, menuType);
    })) === null || __filter === void 0 ? void 0 : __filter.length) > 0 && productQualifiesForAtLeastOneOffer(product.specialData.bogoSpecials, product);
}
export function productQualifiesForAtLeastOneOffer(offers, product) {
    return _.some(offers, function(offer) {
        return !productIsExcludedFromOffer(product, offer === null || offer === void 0 ? void 0 : offer.specialId) && productHasAtLeastOneQualifyingOption(product, offer === null || offer === void 0 ? void 0 : offer.specialId);
    });
}
export function isNotSolitaryMinimumSpendOffer(offers) {
    return _.some(offers, function(param) {
        var totalSpend = param.totalSpend;
        return !(totalSpend === null || totalSpend === void 0 ? void 0 : totalSpend.enabled);
    });
}
export var filterPastSpecials = function(special) {
    var _special_recurring, _special_recurring1;
    // Analogous to "past" Mongo-based logic
    var now = moment().toDate();
    var basicFilters = special.active;
    var optionalFilters = special.complete || !special.isRecurring && special.endStamp < now || special.isRecurring && ((_special_recurring = special.recurring) === null || _special_recurring === void 0 ? void 0 : _special_recurring.setEndDate) && ((_special_recurring1 = special.recurring) === null || _special_recurring1 === void 0 ? void 0 : _special_recurring1.endDate) < now;
    return basicFilters && optionalFilters;
};
export function filterProductsBasedOnSpecials(serializedProducts, pricingType, specialId, specialType, specialIds) {
    if (Array.isArray(specialIds) && specialIds.length === 0) {
        return [];
    }
    var idSet = (specialIds === null || specialIds === void 0 ? void 0 : specialIds.length) > 0 ? new Set(specialIds) : null;
    return _.filter(serializedProducts, function(product) {
        var _product_specialData, _product_specialData1;
        if (_.isEmpty(product === null || product === void 0 ? void 0 : product.specialData)) {
            return false;
        }
        var viewingIndividualSpecialsPage = !_.isNil(specialId);
        var offerSpecialsMatchingMenu = _.filter(((_product_specialData = product.specialData) === null || _product_specialData === void 0 ? void 0 : _product_specialData.bogoSpecials) || [], function(special) {
            return specialMatchesMenuType(special, pricingType);
        });
        var saleSpecialsMatchingMenu = _.filter(((_product_specialData1 = product.specialData) === null || _product_specialData1 === void 0 ? void 0 : _product_specialData1.saleSpecials) || [], function(special) {
            return specialMatchesMenuType(special, pricingType);
        });
        // preOrderType-restricted sale specials attach to a product without writing
        // recSpecialPrices/medicalSpecialPrices (price application happens at checkout instead).
        // For those entries productHasSaleSpecial() returns false because it inspects the price
        // arrays, so we accept the match on id alone when the entry carries a preOrderType.
        var saleEntryIsPreOrderTypeRestricted = function(special) {
            return _.isArray(special === null || special === void 0 ? void 0 : special.preOrderType) && special.preOrderType.length > 0;
        };
        if (idSet) {
            var matchesSale = _.some(saleSpecialsMatchingMenu, function(special) {
                var matchesId = idSet.has(special === null || special === void 0 ? void 0 : special.specialId) || idSet.has(special === null || special === void 0 ? void 0 : special.sourceId);
                if (!matchesId) return false;
                return saleEntryIsPreOrderTypeRestricted(special) || productHasSaleSpecial({
                    product: product,
                    menuType: pricingType
                });
            });
            if (matchesSale) return true;
            return _.some(offerSpecialsMatchingMenu, function(special) {
                var matchesId = idSet.has(special === null || special === void 0 ? void 0 : special.specialId) || idSet.has(special === null || special === void 0 ? void 0 : special.sourceId);
                if (!matchesId) return false;
                var offerId = (special === null || special === void 0 ? void 0 : special.specialId) || (special === null || special === void 0 ? void 0 : special.sourceId);
                return !productIsExcludedFromOffer(product, offerId) && productHasAtLeastOneQualifyingOption(product, offerId);
            });
        }
        if (viewingIndividualSpecialsPage) {
            if (specialType === 'sale') {
                var productIsOnSale = productHasSaleSpecial({
                    product: product,
                    menuType: pricingType
                });
                return _.some(saleSpecialsMatchingMenu, function(special) {
                    var matchesId = (special === null || special === void 0 ? void 0 : special.specialId) === specialId || (special === null || special === void 0 ? void 0 : special.sourceId) === specialId;
                    if (!matchesId) return false;
                    return saleEntryIsPreOrderTypeRestricted(special) || productIsOnSale;
                });
            }
            var isNotExcluded = !productIsExcludedFromOffer(product, specialId);
            var productQualifies = productHasAtLeastOneQualifyingOption(product, specialId);
            return _.some(offerSpecialsMatchingMenu, function(special) {
                return ((special === null || special === void 0 ? void 0 : special.specialId) === specialId || (special === null || special === void 0 ? void 0 : special.sourceId) === specialId) && isNotExcluded && productQualifies;
            });
        }
        var currentProductHasSaleSpecial = saleSpecialsMatchingMenu.length > 0 && (productHasSaleSpecial({
            product: product,
            menuType: pricingType
        }) || _.some(saleSpecialsMatchingMenu, saleEntryIsPreOrderTypeRestricted));
        var currentProductQualifiesForAtLeastOneOffer = offerSpecialsMatchingMenu.length > 0 && productQualifiesForAtLeastOneOffer(offerSpecialsMatchingMenu, product);
        return currentProductHasSaleSpecial || currentProductQualifiesForAtLeastOneOffer;
    });
}
/**
 * @template T
 * @param {readonly T[]} specials
 * @returns {T[]}
 */ export var sortSpecialCards = function(specials) {
    return _.sortBy(specials, [
        'displayRank',
        'endStamp',
        "recurring.endDate"
    ]);
};
export var getSpecialsBasePath = function(param) {
    var dispensaryId = param.dispensaryId, enterpriseId = param.enterpriseId, scope = param.scope;
    var isEnterpriseSpecial = scope === 'enterprise';
    var dispensaryOrEnterpriseId = isEnterpriseSpecial && enterpriseId ? enterpriseId : dispensaryId;
    var dispensaryOrEnterpriseText = isEnterpriseSpecial && enterpriseId ? 'enterprise' : 'dispensaries';
    return "/".concat(dispensaryOrEnterpriseText, "/").concat(dispensaryOrEnterpriseId, "/promote/specials");
};
export var getEditUrl = function(_param) {
    var specialId = _param._id, enterpriseSpecialId = _param.enterpriseSpecialId, special = _object_without_properties(_param, [
        "_id",
        "enterpriseSpecialId"
    ]);
    return "".concat(getSpecialsBasePath(special), "/edit/").concat(enterpriseSpecialId || specialId);
};
export var getCurrentStepIndex = function(isReadOnly, SpecialsState) {
    var stepIndex = 1;
    if (isReadOnly) {
        var specialSteps = _.reduce(SpecialsState.completedSteps, function(result, value, key) {
            if (value) {
                result.push(key);
            }
            return result;
        }, []);
        stepIndex = specialSteps.length - 1;
    }
    // This is used to reset the index to 0 when customizing Discount SYnc POS Sales,
    // since we only show one step, Menu Design
    if (SpecialsState.isPOSSpecial) {
        stepIndex = 0;
    }
    return stepIndex;
};
export var getEarliestStartStamp = function(special) {
    if (special.earliestStartStamp) {
        return special.earliestStartStamp;
    }
    return special.startStamp;
};
export var includeSettingsStep = function(param) {
    var globalSpecialsSettings = param.globalSpecialsSettings, special = param.special;
    return globalSpecialsSettings.enableIndividualDiscountStacking || globalSpecialsSettings.enableIndividualSpecialPrecedence || !_.isNil(special.discountStacking) || !_.isNil(special.discountPrecedence);
};
export var isSettingsStepComplete = function(special) {
    return !_.isNil(special.discountStacking) || !_.isNil(special.discountPrecedence);
};
export var removePOSOnlyFieldsFromBogo = function(special) {
    var bogoConditions = special.bogoConditions, bogoRewards = special.bogoRewards;
    var fieldsToOmit = [
        'requiresSingleSku',
        'totalQuantity',
        'totalWeight',
        'totalSpend',
        'discountAmount',
        'discountType',
        'applicationRules'
    ];
    special.bogoConditions = _.map(bogoConditions, function(condition) {
        return _.omit(condition, fieldsToOmit);
    });
    special.bogoRewards = _.map(bogoRewards, function(reward) {
        return _.omit(reward, fieldsToOmit);
    });
};
/**
 * Determines if a product's weight satisfies the conditions for any applicable sale specials
 *
 * @param {Object} product - The product to check
 * @param {Array<Object>} [saleSpecials=[]] - Array of sale special objects to check against
 * @param {string} [formattedWeight='N/A'] - The formatted weight to check (e.g., '1g', '1/8oz')
 * @param {boolean} [withSpecialData=false] - If true, returns the matching special data along with the result
 * @returns {boolean|Object} Returns either:
 *   - boolean: true if product weight satisfies any sale special conditions
 *   - Object: { satisfies: boolean, special: Object } if withSpecialData is true
 */ export var productSatisfiesSaleWeight = function(product) {
    var saleSpecials = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], formattedWeight = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "N/A", withSpecialData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    // If there are no sale specials, return early
    if (saleSpecials === null || (saleSpecials === null || saleSpecials === void 0 ? void 0 : saleSpecials.length) < 1) {
        return withSpecialData ? {
            appliedSpecials: [],
            result: false
        } : false;
    }
    var __reduce = _.reduce(saleSpecials, function(result, special) {
        if (!_.isEmpty(special === null || special === void 0 ? void 0 : special.saleDiscounts)) {
            result.threeDotFiveSales.push(special); // 3.5 special
        } else if (_.values(special === null || special === void 0 ? void 0 : special.specialRestrictions).length > 0) {
            result.salesWithRestrictions.push(special); // < 3.5 special
        } else {
            result.salesWithoutRestrictions.push(special); // < 3.5 special
        }
        return result;
    }, {
        threeDotFiveSales: [],
        salesWithRestrictions: [],
        salesWithoutRestrictions: []
    }), salesWithRestrictions = __reduce.salesWithRestrictions, salesWithoutRestrictions = __reduce.salesWithoutRestrictions, threeDotFiveSales = __reduce.threeDotFiveSales;
    // If we have a < 3.5 sale without specialRestrictions, then the sale can apply as normal
    if (salesWithoutRestrictions.length > 0) {
        return withSpecialData ? {
            appliedSpecials: _to_consumable_array(saleSpecials),
            result: true
        } : true;
    }
    var appliedSpecials = [];
    var formattedWeightInGrams = getProductWeight(formattedWeight);
    var hasApplicableSpecial;
    // For 3.5 sales
    if (threeDotFiveSales.length > 0) {
        _.forEach(threeDotFiveSales, function(special) {
            var _special_saleDiscounts;
            var _special_eligibleProductOptions;
            // 3.5 sales should already have this property after calculation in the serializer
            var eligibleProductOptions = (_special_eligibleProductOptions = special === null || special === void 0 ? void 0 : special.eligibleProductOptions) !== null && _special_eligibleProductOptions !== void 0 ? _special_eligibleProductOptions : eligibleProductOptionsForRestriction(product, (_special_saleDiscounts = special.saleDiscounts) === null || _special_saleDiscounts === void 0 ? void 0 : _special_saleDiscounts[0], 'inclusion', special);
            _.forEach(eligibleProductOptions, function(productOption) {
                // Try to match on the string option itself first before weight conversion
                if (formattedWeight === productOption || formattedWeightInGrams === getProductWeight(productOption)) {
                    appliedSpecials.push({
                        specialId: special._id,
                        weight: productOption
                    });
                    return false;
                }
                return true; // consistent return
            });
        });
    }
    // For < 3.5 sales with specialRestrictions
    if (salesWithRestrictions.length > 0) {
        var salesType = getSalesType(product);
        var specialRestrictions = _.map(salesWithRestrictions, function(s, i) {
            return _define_property({}, s._id || s.specialId || i, s.specialRestrictions);
        });
        var hasMatchingRestriction = false;
        _.forEach(specialRestrictions, function(special) {
            var specialId = _.keys(special)[0];
            var restrictions = Object.entries(_.values(special)[0] || {});
            _.forEach(restrictions, function(param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], condition = _param[1];
                var _key_split;
                // if we found a matching restriction, see if this product weight applies
                var enterpriseKey = (key === null || key === void 0 ? void 0 : key.startsWith('EPID_')) ? (_key_split = key.split('EPID_')) === null || _key_split === void 0 ? void 0 : _key_split[1] : key;
                if (_.includes(salesType, key) || _.includes(salesType, enterpriseKey)) {
                    hasMatchingRestriction = true;
                    var weights = _.map(condition.weights || [
                        condition.weight
                    ], function(conditionWeight) {
                        return getProductWeight(conditionWeight);
                    });
                    if (saleSatisfiesWeightCondition(formattedWeightInGrams, condition.weightOperator, weights)) {
                        if (!_.includes(appliedSpecials, specialId)) {
                            appliedSpecials.push({
                                specialId: specialId,
                                weight: condition.weight
                            });
                        }
                    }
                }
            });
        });
        hasApplicableSpecial = appliedSpecials.length > 0 || !hasMatchingRestriction;
    } else {
        hasApplicableSpecial = appliedSpecials.length > 0;
    }
    return withSpecialData ? {
        appliedSpecials: appliedSpecials,
        result: hasApplicableSpecial
    } : hasApplicableSpecial;
};
export var getSalesType = function(product) {
    var _product_brand, _product_brand1;
    var _product_enterpriseProductId;
    return [
        product.productBrandId || product.brandId || (product === null || product === void 0 ? void 0 : (_product_brand = product.brand) === null || _product_brand === void 0 ? void 0 : _product_brand.id) || product.productBrandName || product.brandName || (product === null || product === void 0 ? void 0 : (_product_brand1 = product.brand) === null || _product_brand1 === void 0 ? void 0 : _product_brand1.name),
        product.productCategory || product.type || product.category,
        product.productSubcategory || product.subcategory,
        product._id || product.id,
        !product.subcategory ? "uncategorized_".concat(product.productCategory || product.type || product.category) : null,
        (_product_enterpriseProductId = product === null || product === void 0 ? void 0 : product.enterpriseProductId) !== null && _product_enterpriseProductId !== void 0 ? _product_enterpriseProductId : null
    ];
};
export var getSpecialBadgeType = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, saleSpecials = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], weights = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var satisfies = [];
    var appliedSpecials = [];
    _.forEach(weights, function(weight) {
        var data = productSatisfiesSaleWeight(product, saleSpecials, weight, true);
        if (data.result) {
            satisfies.push(true);
            _.forEach(data.appliedSpecials, function(special) {
                if ((special === null || special === void 0 ? void 0 : special.specialId) && !_.find(appliedSpecials, [
                    "specialId",
                    special.specialId
                ])) {
                    appliedSpecials.push(_object_spread({}, special));
                }
            });
        } else {
            satisfies.push(false);
        }
    });
    var uniqueWeights = _.map(appliedSpecials, "weight");
    if (_.every(satisfies, Boolean) && (uniqueWeights.length === 0 || satisfies.length === uniqueWeights.length)) {
        return "pill";
    }
    if (_.some(satisfies, Boolean)) {
        return "label";
    }
    return "none";
};
export var getProductKeyFromRule = function(rule) {
    var _rule_enterpriseProductIds, _rule_productIds;
    var _rule_enterpriseProductIds_, _ref, _ref1, _ref2;
    return (_ref2 = (_ref1 = (_ref = (_rule_enterpriseProductIds_ = rule === null || rule === void 0 ? void 0 : (_rule_enterpriseProductIds = rule.enterpriseProductIds) === null || _rule_enterpriseProductIds === void 0 ? void 0 : _rule_enterpriseProductIds[0]) !== null && _rule_enterpriseProductIds_ !== void 0 ? _rule_enterpriseProductIds_ : rule === null || rule === void 0 ? void 0 : rule.enterpriseProductId) !== null && _ref !== void 0 ? _ref : rule === null || rule === void 0 ? void 0 : (_rule_productIds = rule.productIds) === null || _rule_productIds === void 0 ? void 0 : _rule_productIds[0]) !== null && _ref1 !== void 0 ? _ref1 : rule === null || rule === void 0 ? void 0 : rule.productId) !== null && _ref2 !== void 0 ? _ref2 : rule._id;
};
// item accepts either a product object, cart-item store object, or breakdownItem object from cart calculations
export var formatDiscountForDisplay = function() {
    var originalPrice = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, discountedPrice = arguments.length > 1 ? arguments[1] : void 0, item = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, type = arguments.length > 3 ? arguments[3] : void 0, weightOverride = arguments.length > 4 ? arguments[4] : void 0, isMobile = arguments.length > 5 ? arguments[5] : void 0, forceDollarFormat = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
    var _workableItem_specialData;
    if (_.isNil(discountedPrice)) {
        return null; // Return early if there is no discount
    }
    var startingPrice = parseFloat("".concat(originalPrice));
    var reducedPrice = parseFloat("".concat(discountedPrice));
    if (_.isNaN(startingPrice) || _.isNaN(reducedPrice)) {
        return null; // Return early if startingPrice or reducedPrice are NaN
    }
    reducedPrice = reducedPrice <= 0 ? 0 : reducedPrice;
    if (reducedPrice >= startingPrice) {
        return null; // Return early if reducedPrice would result in inverse discount
    }
    var formattedDiscount = 'Discounted!';
    var workableItem = item;
    // If item is a cart-item store object, grab the breakdownItem
    if (_.isFunction(workableItem === null || workableItem === void 0 ? void 0 : workableItem.getBreakdownItem)) {
        workableItem = workableItem.getBreakdownItem();
    }
    var bogoSavings = workableItem === null || workableItem === void 0 ? void 0 : workableItem.bogoSavings;
    var saleSpecials = workableItem === null || workableItem === void 0 ? void 0 : (_workableItem_specialData = workableItem.specialData) === null || _workableItem_specialData === void 0 ? void 0 : _workableItem_specialData.saleSpecials;
    var _ref;
    var weight = (_ref = weightOverride !== null && weightOverride !== void 0 ? weightOverride : workableItem === null || workableItem === void 0 ? void 0 : workableItem.option) !== null && _ref !== void 0 ? _ref : workableItem === null || workableItem === void 0 ? void 0 : workableItem.Option;
    var formatInDollars;
    if (type === 'bogo' || !_.isEmpty(bogoSavings)) {
        // Since offers are conditional and always displayed on the cart or at checkout, we don't have to concern ourselves
        // with weights / menu display elsewhere and can rely on the receipt data alone
        formatInDollars = forceDollarFormat || _.some(bogoSavings === null || bogoSavings === void 0 ? void 0 : bogoSavings.individual, function(discount) {
            return !discount.displayAsPercentDiscount && (discount.dollarDiscount || discount.targetPrice);
        });
        var suffix = isMobile ? 'discount!' : 'discount applied!';
        formattedDiscount = formatInDollars ? "$".concat((startingPrice - reducedPrice).toFixed(2), " ").concat(suffix) : "".concat(((1 - reducedPrice / startingPrice) * 100.0).toFixed(0), "% ").concat(suffix);
    } else if (type === 'sale' || !_.isEmpty(saleSpecials)) {
        formatInDollars = forceDollarFormat || _.some(saleSpecials, function(special) {
            if (weight) {
                return productSatisfiesSaleWeight(workableItem, [
                    special
                ], weight) && (special.dollarDiscount || special.targetPrice);
            }
            return special.dollarDiscount || special.targetPrice;
        });
        formattedDiscount = formatInDollars ? "$".concat((startingPrice - reducedPrice).toFixed(2), " off") : "".concat(((1 - reducedPrice / startingPrice) * 100.0).toFixed(0), "% off");
    }
    return formattedDiscount;
};
export var specialsLogger = function(param) {
    var logger = param.logger, data = param.data, _param_level = param.level, level = _param_level === void 0 ? 'debug' : _param_level;
    var calculationsLogger = logger !== null && logger !== void 0 ? logger : console;
    switch(level){
        case 'debug':
            calculationsLogger.debug(data);
            break;
        case 'info':
            calculationsLogger.info(data);
            break;
        case 'warn':
            calculationsLogger.warn(data);
            break;
        case 'error':
            calculationsLogger.error(data);
            break;
        default:
            calculationsLogger.debug(data);
    }
};
// eslint-disable-next-line import/no-cycle
export * from './specials/excluded-products';
// eslint-disable-next-line import/no-cycle
export { default as excludedProducts } from './specials/excluded-products';
